import { FormlyFieldConfig } from '@ngx-formly/core';

export function nameValidatorMessage(error: unknown, field: FormlyFieldConfig) {
  return 'Please enter a valid name';
}
